import { IOperationPolDataTry, IOperationPolDetail, isAutoPolTry } from '../../processes/models/processes.models';

/** Nº de intentos POL en `data`: filas auto (`lifeTest` no vacío). */
export function getPolDataTriesDisplayCount(data: IOperationPolDataTry[] | undefined | null): number {
	const rows = data ?? [];
	return Math.max(0, rows.filter((t) => isAutoPolTry(t)).length);
}

/**
 * Etiqueta para el tag «Nº intentos» en detalle POL; sin filas → notAvailable.
 * POL estática: payload [{ general }, { status }] no pasa type guards → count 0 (NIF-822).
 */
export function getPolTriesCountLabel(
	pol: IOperationPolDetail | undefined | null,
	notAvailable: string,
): string {
	const data = pol?.data;
	if (!data?.length) {
		return notAvailable;
	}
	const count = getPolDataTriesDisplayCount(data);
	if (count === 0 && pol?.mode !== 'auto') {
		return '1';
	}
	return String(count);
}
